var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutfordeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 7H14.6667M14.6667 7L12.4447 4.33333M14.6667 7L12.4447 9.66667M9.33333 3.66667V2.44933C9.33332 2.26492 9.29506 2.08251 9.22095 1.91363C9.14685 1.74476 9.03852 1.59309 8.90281 1.46822C8.7671 1.34335 8.60696 1.24799 8.43252 1.18817C8.25807 1.12834 8.07311 1.10536 7.88933 1.12067L2.556 1.56467C2.2227 1.59243 1.91201 1.74443 1.68553 1.99054C1.45906 2.23665 1.33335 2.55888 1.33333 2.89333V11.1067C1.33335 11.4411 1.45906 11.7634 1.68553 12.0095C1.91201 12.2556 2.2227 12.4076 2.556 12.4353L7.88933 12.88C8.07317 12.8953 8.25818 12.8723 8.43268 12.8124C8.60717 12.7526 8.76734 12.6572 8.90306 12.5322C9.03878 12.4073 9.14709 12.2555 9.22116 12.0866C9.29522 11.9176 9.33342 11.7351 9.33333 11.5507V10.3333",
    stroke: "#405189",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfordeliveryIcon);
export default __webpack_public_path__ + "static/media/outfordelivery_icon.1e22d60ab3049914f2038c899a926c72.svg";
export { ForwardRef as ReactComponent };